import React, { Component } from "react";
import { Card, CardBody, UncontrolledAlert } from "reactstrap";
import DataTable from "../Shared/DataTable";
import { MdModeEdit, MdDelete } from "react-icons/md";
const MockApi = [
    {
        id: 33,
        name: "spoon",
    },
    { id: 12, name: "cup" },
];
export class FoodMetricTable extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const columns = [
            {
                Header: "Name",
                accessor: "name",
                style: {
                    textAlign: "center",
                },
            },
        ];

        const { match, fetching, data, error, filterData, selectRow, pages, page, pageSize, deleteFormMeteric, showModal, setPageNumber, setPageSize } = this.props;

        const actions = [
            {
                name: "edit",
                btnText: "Edit",
                btnAction: selectRow,
                btnClass: "btn-primary",
                btnIcon: MdModeEdit,
            },
            {
                name: "delete",
                btnText: "Delete",
                btnAction: showModal,
                btnClass: "btn-danger",
                btnIcon: MdDelete,
            },
        ];

        return (
            <div>
           
                <Card className="joyride5">
                    <CardBody>
                        {error && <UncontrolledAlert color="danger">{error.message}</UncontrolledAlert>}
                        <DataTable
                            columns={columns}
                            loading={fetching}
                            manual={true}
                            pages={pages}
                            page={page}
                            pageSize={pageSize}
                            urlParams={match}
                            data={data ? data.data : []}
                            count={data ? data.count : 0}
                            defaultPageSize={5}
                            deleteRow={deleteFormMeteric}
                            selectRow={selectRow}
                            showModal={showModal}
                            filterData={filterData}
                            setPageNumber={setPageNumber}
                            setPageSize={setPageSize}
                            searchParam="name"
                            hideSearchParam={true}
                            //searchPlaceholder="Search by name"
                            actions={actions}
                        />
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default FoodMetricTable;
